import { AccountingStatusFilter } from '~/business-logic/qboStatusFilterLogic';
import { useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { useLocaleKeys } from '~/i18n';
export const useFetchPayouts = function useFetchPayouts(params) {
    let { refreshOnHookMount = false } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { api } = useStoreActions();
    const { t: errorTexts } = useLocaleKeys('errors');
    const { qboIntegration, xeroIntegration, search, pageSize, pageNumber, sort, useExternalApi } = params;
    const qbo = qboIntegration !== AccountingStatusFilter.All ? qboIntegration : undefined;
    const xero = xeroIntegration !== AccountingStatusFilter.All ? xeroIntegration : undefined;
    const searchOrUndef = search || undefined;
    const queryKey = [
        QueryKeys.Payouts,
        useExternalApi ? 'externalApi' : 'scout',
        qbo,
        xero,
        searchOrUndef,
        pageSize,
        pageNumber,
        sort
    ];
    const { data, isLoading, isBackgroundLoading, refresh, error } = useQueryState({
        queryKey,
        queryFn: ()=>{
            const payload = {
                qboIntegration: qbo,
                xeroIntegration: xero,
                search: searchOrUndef,
                pageSize,
                pageNumber,
                sort
            };
            return useExternalApi ? api.payout.getAllFromExternalApi(payload) : api.payout.getAllFromScout(payload);
        },
        keepPreviousData: true,
        staleTime: 0,
        refreshOnHookMount,
        toasts: {
            errorMessage: errorTexts.unexpected(),
            errorTestId: 'fetch-payouts-error'
        }
    });
    return {
        data,
        isLoading,
        isBackgroundLoading,
        refresh,
        error
    };
};
